/* ==========================================================================
   MUQ OFFICIAL — Header JavaScript  (v3 — 1-char predictive search + sidebar toggle)
   ========================================================================== */

(function() {
  'use strict';

  /* ------------------------------------------------------------------------
     0. SCROLL LOCK HELPER
     ------------------------------------------------------------------------ */
  const measureScrollbarWidth = () => {
    const outer = document.createElement('div');
    outer.style.cssText = 'visibility:hidden;overflow:scroll;width:100px;height:100px;position:absolute;top:-9999px;';
    document.body.appendChild(outer);

    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    document.body.removeChild(outer);
    return scrollbarWidth;
  };

  const setScrollbarWidth = () => {
    const scrollbarWidth = measureScrollbarWidth();
    document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
  };

  setScrollbarWidth();
  window.addEventListener('resize', setScrollbarWidth);

  /* ------------------------------------------------------------------------
     1. DIRECTIONAL STICKY HEADER
     ------------------------------------------------------------------------ */
  const announcementBar = document.querySelector('[data-announcement-bar]');
  const headerEl = document.querySelector('[data-header]');

  let edmeSearchForceTimerA = null;
  let edmeSearchForceTimerB = null;
  let edmeSearchForceTimerC = null;

  function forceHeaderVisibleForSearch() {
    const header = document.querySelector('[data-header]') || document.querySelector('.header');
    const announcement = document.querySelector('[data-announcement-bar]') || document.querySelector('.announcement-bar');

    document.documentElement.classList.add('edme-search-opening');
    document.body.classList.add('announcement-hidden');

    if (announcement) {
      announcement.classList.add('is-hidden');
      announcement.style.transform = 'translateY(-100%)';
      announcement.style.opacity = '0';
      announcement.style.visibility = 'hidden';
      announcement.style.pointerEvents = 'none';
    }

    if (header) {
      header.classList.add('is-stuck');
      header.classList.remove('is-hidden');
      header.style.top = '0';
      header.style.transform = 'translateY(0)';
      header.style.opacity = '1';
      header.style.visibility = 'visible';
      header.style.pointerEvents = 'auto';
    }
  }

  function forceHeaderVisibleForSearchWithRetries() {
    clearTimeout(edmeSearchForceTimerA);
    clearTimeout(edmeSearchForceTimerB);
    clearTimeout(edmeSearchForceTimerC);

    forceHeaderVisibleForSearch();

    requestAnimationFrame(() => {
      forceHeaderVisibleForSearch();
    });

    edmeSearchForceTimerA = setTimeout(forceHeaderVisibleForSearch, 60);
    edmeSearchForceTimerB = setTimeout(forceHeaderVisibleForSearch, 180);
    edmeSearchForceTimerC = setTimeout(forceHeaderVisibleForSearch, 420);
  }

  function releaseHeaderAfterSearch() {
    clearTimeout(edmeSearchForceTimerA);
    clearTimeout(edmeSearchForceTimerB);
    clearTimeout(edmeSearchForceTimerC);

    const header = document.querySelector('[data-header]') || document.querySelector('.header');
    const announcement = document.querySelector('[data-announcement-bar]') || document.querySelector('.announcement-bar');
    const currentScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    const isAtTop = currentScrollY <= 10;

    document.documentElement.classList.remove('edme-search-opening');

    if (header) {
      header.style.top = '';
      header.style.transform = '';
      header.style.opacity = '';
      header.style.visibility = '';
      header.style.pointerEvents = '';

      if (isAtTop) {
        header.classList.remove('is-stuck');
        header.classList.remove('is-hidden');
      } else {
        header.classList.add('is-stuck');
        header.classList.remove('is-hidden');
      }
    }

    if (announcement) {
      announcement.style.transform = '';
      announcement.style.opacity = '';
      announcement.style.visibility = '';
      announcement.style.pointerEvents = '';

      if (isAtTop) {
        announcement.classList.remove('is-hidden');
        document.body.classList.remove('announcement-hidden');
      } else {
        announcement.classList.add('is-hidden');
        document.body.classList.add('announcement-hidden');
      }
    }
  }

  if (headerEl) {
    const TOP_THRESHOLD = 10;
    const SCROLL_DELTA = 5;

    let lastScrollY = window.pageYOffset;
    let ticking = false;

    const updateHeader = () => {
      const currentScrollY = window.pageYOffset;

      if (
        document.body.classList.contains('search-open') ||
        document.documentElement.classList.contains('edme-search-opening')
      ) {
        forceHeaderVisibleForSearch();
        lastScrollY = currentScrollY;
        ticking = false;
        return;
      }

      const delta = currentScrollY - lastScrollY;

      if (Math.abs(delta) < SCROLL_DELTA) {
        ticking = false;
        return;
      }

      const direction = delta > 0 ? 'down' : 'up';
      const isAtTop = currentScrollY <= TOP_THRESHOLD;

      if (isAtTop) {
        announcementBar?.classList.remove('is-hidden');
        headerEl.classList.remove('is-stuck');
        headerEl.classList.remove('is-hidden');
        document.body.classList.remove('announcement-hidden');
      } else if (direction === 'down') {
        announcementBar?.classList.add('is-hidden');
        headerEl.classList.add('is-stuck');
        headerEl.classList.add('is-hidden');
        document.body.classList.add('announcement-hidden');
      } else if (direction === 'up') {
        announcementBar?.classList.add('is-hidden');
        headerEl.classList.add('is-stuck');
        headerEl.classList.remove('is-hidden');
        document.body.classList.add('announcement-hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  } else if (headerEl && !announcementBar) {
    headerEl.classList.add('is-stuck');
    document.body.classList.add('announcement-hidden');
  }

  document.addEventListener('pointerdown', (event) => {
    if (!event.target.closest('[data-search-toggle]')) return;
    // Kapatma butonuna basıldıysa header force etme — kapanmayı engellemesin
    if (event.target.closest('[data-search-close], .header__search-trigger-close')) return;
    forceHeaderVisibleForSearchWithRetries();
  }, true);

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-search-toggle]')) return;
    if (event.target.closest('[data-search-close], .header__search-trigger-close')) return;
    forceHeaderVisibleForSearchWithRetries();
  }, true);

  window.addEventListener('scroll', () => {
    if (
      !document.body.classList.contains('search-open') &&
      !document.documentElement.classList.contains('edme-search-opening')
    ) {
      return;
    }

    forceHeaderVisibleForSearch();
  }, { passive: true });

  /* ------------------------------------------------------------------------
     2. MEGA MENU
     ------------------------------------------------------------------------ */
  const navItems = document.querySelectorAll('[data-nav-item]');
  const megamenuPanels = document.querySelectorAll('[data-megamenu-panel]');
  let activeNavItem = null;
  let activePanel = null;
  let megamenuTimeout = null;

  const closeMegamenu = () => {
    if (activeNavItem) {
      activeNavItem.classList.remove('is-active');
      activeNavItem.querySelector('[data-megamenu-trigger]')?.setAttribute('aria-expanded', 'false');
      activeNavItem = null;
    }

    if (activePanel) {
      activePanel.classList.remove('is-open');
      activePanel.setAttribute('aria-hidden', 'true');
      activePanel = null;
    }
  };

  const openMegamenu = (item) => {
    const trigger = item.querySelector('[data-megamenu-trigger]');
    if (!trigger) return;

    const navTitle = item.dataset.navTitle;
    const panel = document.querySelector(`[data-megamenu-panel="${navTitle}"]`);

    closeMegamenu();

    item.classList.add('is-active');
    trigger.setAttribute('aria-expanded', 'true');
    activeNavItem = item;

    if (panel) {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      activePanel = panel;
    }
  };

  const isDesktop = () => window.innerWidth >= 1024;

  navItems.forEach(item => {
    const trigger = item.querySelector('[data-megamenu-trigger]');
    if (!trigger) return;

    item.addEventListener('mouseenter', () => {
      clearTimeout(megamenuTimeout);
      openMegamenu(item);
    });

    item.addEventListener('mouseleave', () => {
      megamenuTimeout = setTimeout(() => {
        const navTitle = item.dataset.navTitle;
        const panel = document.querySelector(`[data-megamenu-panel="${navTitle}"]`);

        if (panel && !panel.matches(':hover')) {
          closeMegamenu();
        }
      }, 150);
    });

    trigger.addEventListener('click', (event) => {
      if (isDesktop()) return;

      event.preventDefault();

      const isActive = item.classList.contains('is-active');

      if (isActive) {
        closeMegamenu();
      } else {
        openMegamenu(item);
      }
    });
  });

  megamenuPanels.forEach(panel => {
    panel.addEventListener('mouseenter', () => {
      clearTimeout(megamenuTimeout);
    });

    panel.addEventListener('mouseleave', () => {
      megamenuTimeout = setTimeout(closeMegamenu, 150);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeNavItem) {
      closeMegamenu();
    }
  });

  document.addEventListener('click', (event) => {
    if (
      activeNavItem &&
      !activeNavItem.contains(event.target) &&
      !activePanel?.contains(event.target)
    ) {
      closeMegamenu();
    }
  });

  /* ------------------------------------------------------------------------
     5. PREDICTIVE SEARCH  (v3 — TEK HARFTE tetiklenir, sidebar gizlenir,
        input boşalınca kategoriler anında geri gelir)
     ------------------------------------------------------------------------ */
  const searchInput = document.querySelector('[data-search-input]');
  const searchForm = document.querySelector('[data-search-form]');
  const searchMain = document.querySelector('.search-overlay__main');
  const searchOverlayEl = document.querySelector('[data-search-overlay]');
  const resultsPanel = document.querySelector('.search-overlay__results');
  const resultsGrid = document.querySelector('[data-results-grid]');
  const resultsLoading = document.querySelector('[data-results-loading]');
  const resultsEmpty = document.querySelector('[data-results-empty]');

  let searchDebounce = null;
  let searchRequestId = 0; // Geciken eski isteğin yeni durumu ezmesini önler

  const escapeHtml = (text) => {
    const div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  };

  const resetPredictiveSearch = () => {
    searchRequestId++; // Uçuştaki tüm istekleri geçersiz kıl

    searchMain?.classList.remove('has-results');
    searchOverlayEl?.classList.remove('has-results'); // Sidebar (En İyi Kategoriler vb.) geri gelir
    resultsPanel?.classList.remove('is-visible');
    resultsLoading?.classList.remove('is-visible');
    resultsEmpty?.classList.remove('is-visible');

    if (resultsGrid) {
      resultsGrid.innerHTML = '';
    }
  };

  const performPredictiveSearch = async (query) => {
    const cleanQuery = (query || '').trim();

    // TEK HARF yeterli — input boşsa varsayılan görünüme dön
    if (cleanQuery.length < 1) {
      resetPredictiveSearch();
      return;
    }

    const requestId = ++searchRequestId;

    searchMain?.classList.add('has-results');
    searchOverlayEl?.classList.add('has-results'); // Sidebar (En İyi Kategoriler vb.) gizlenir
    resultsPanel?.classList.add('is-visible');
    resultsLoading?.classList.add('is-visible');
    resultsEmpty?.classList.remove('is-visible');

    if (resultsGrid) {
      resultsGrid.innerHTML = '';
    }

    try {
      const url =
        `/search/suggest?q=${encodeURIComponent(cleanQuery)}` +
        `&section_id=edme-product-card-renderer` +
        `&resources[type]=product` +
        `&resources[limit]=10` +
        `&resources[options][unavailable_products]=last` +
        `&resources[options][fields]=title,product_type,variants.title,vendor`;

      const res = await fetch(url, {
        headers: {
          'Accept': 'text/html'
        }
      });

      // Bu istek beklenirken kullanıcı yazmaya devam ettiyse / sildiyse: sonucu yok say
      if (requestId !== searchRequestId) return;

      if (!res.ok) {
        throw new Error('Predictive search section request failed');
      }

      const html = await res.text();

      if (requestId !== searchRequestId) return;

      const temp = document.createElement('div');
      temp.innerHTML = html;

      const renderedProducts = temp.querySelector('[data-edme-product-card-renderer]');
      const productCards = renderedProducts ? renderedProducts.innerHTML.trim() : '';

      resultsLoading?.classList.remove('is-visible');

      if (!productCards) {
        resultsEmpty?.classList.add('is-visible');
        return;
      }

      if (resultsGrid) {
        resultsGrid.innerHTML = productCards;
      }

      document.dispatchEvent(new CustomEvent('edme:search-results-rendered', {
        detail: { container: resultsGrid }
      }));
    } catch (err) {
      if (requestId !== searchRequestId) return;

      console.error('[MUQ Search] Predictive section render error:', err);

      resultsLoading?.classList.remove('is-visible');
      resultsEmpty?.classList.add('is-visible');
    }
  };

  searchInput?.addEventListener('input', (event) => {
    clearTimeout(searchDebounce);

    const query = event.target.value.trim();

    // Boşaldıysa BEKLEMEDEN hemen varsayılana dön → kategoriler anında geri gelir
    if (query.length < 1) {
      resetPredictiveSearch();
      return;
    }

    searchDebounce = setTimeout(() => {
      performPredictiveSearch(query);
    }, 180);
  });

  searchForm?.addEventListener('submit', () => {
    const query = searchInput?.value.trim();

    if (query && query.length >= 1) {
      saveRecentSearch(query);
    }
  });

  /* ------------------------------------------------------------------------
     6. RECENT SEARCHES
     ------------------------------------------------------------------------ */
  const RECENT_KEY = 'muq_recent_searches';
  const MAX_RECENT = 8;
  const RECENT_DISPLAY = 3;

  const getRecentSearches = () => {
    try {
      const data = localStorage.getItem(RECENT_KEY);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  };

  const saveRecentSearch = (query) => {
    if (!query) return;

    let recent = getRecentSearches();

    recent = recent.filter(q => q.toLowerCase() !== query.toLowerCase());
    recent.unshift(query);
    recent = recent.slice(0, MAX_RECENT);

    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(recent));
    } catch {}
  };

  const removeRecentSearch = (query) => {
    let recent = getRecentSearches();

    recent = recent.filter(q => q !== query);

    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(recent));
    } catch {}

    renderRecentSearches();
  };

  const clearAllRecent = () => {
    try {
      localStorage.removeItem(RECENT_KEY);
    } catch {}

    renderRecentSearches();
  };

  const renderRecentSearches = () => {
    const wrapper = document.querySelector('[data-recent-searches-top]');
    const list = document.querySelector('[data-recent-searches]');

    if (!wrapper || !list) return;

    const recent = getRecentSearches().slice(0, RECENT_DISPLAY);

    if (recent.length === 0) {
      wrapper.hidden = true;
      wrapper.setAttribute('aria-hidden', 'true');
      list.innerHTML = '';
      return;
    }

    wrapper.hidden = false;
    wrapper.setAttribute('aria-hidden', 'false');

    list.innerHTML = recent.map(query => `
      <li class="search-overlay__recent-row">
        <button type="button" class="search-overlay__recent-term" data-recent-query="${escapeHtml(query)}">${escapeHtml(query)}</button>
        <button type="button" class="search-overlay__recent-x" aria-label="Sil" data-remove-recent="${escapeHtml(query)}">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </li>
    `).join('');

    list.querySelectorAll('[data-recent-query]').forEach(item => {
      item.addEventListener('click', (event) => {
        if (event.target.closest('[data-remove-recent]')) return;

        const q = item.dataset.recentQuery;
        const inputs = [
          document.querySelector('.header__search-trigger-input'),
          document.querySelector('[data-search-input]')
        ].filter(Boolean);

        inputs.forEach(inp => { inp.value = q; });
        performPredictiveSearch(q);
        if (inputs[0]) inputs[0].focus({ preventScroll: true });
      });
    });

    list.querySelectorAll('[data-remove-recent]').forEach(btn => {
      btn.addEventListener('click', (event) => {
        event.stopPropagation();
        removeRecentSearch(btn.dataset.removeRecent);
      });
    });
  };

  document.querySelector('[data-clear-recent]')?.addEventListener('click', clearAllRecent);

  document.querySelectorAll('[data-keyword]').forEach(link => {
    link.addEventListener('click', () => {
      const keyword = link.dataset.keyword;

      if (keyword) {
        saveRecentSearch(keyword);
      }
    });
  });

  /* ------------------------------------------------------------------------
     7. SEARCH PRODUCTS CAROUSEL
     ------------------------------------------------------------------------ */
  const carousel = document.querySelector('[data-products-carousel]');

  if (carousel) {
    const track = carousel.querySelector('[data-carousel-track]');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');

    const scrollAmount = () => {
      const card =
        track?.querySelector('.edme-product-card-renderer__item') ||
        track?.querySelector('.search-product-card-wrap') ||
        track?.querySelector('.search-product-card') ||
        track?.querySelector('.edme-pcard');

      if (!card) return 300;

      return card.offsetWidth + 16;
    };

    prevBtn?.addEventListener('click', () => {
      track?.scrollBy({ left: -scrollAmount() * 2, behavior: 'smooth' });
    });

    nextBtn?.addEventListener('click', () => {
      track?.scrollBy({ left: scrollAmount() * 2, behavior: 'smooth' });
    });
  }

  /* ------------------------------------------------------------------------
     9. CART AJAX
     ------------------------------------------------------------------------ */
  const cartDrawer = document.querySelector('[data-cart-drawer]');

  const refreshCart = async () => {
    try {
      const res = await fetch('/?section_id=cart-drawer');
      const html = await res.text();
      const tempDiv = document.createElement('div');

      tempDiv.innerHTML = html;

      const newDrawer = tempDiv.querySelector('[data-cart-drawer]');

      if (newDrawer && cartDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;
        attachCartItemListeners();
      }

      const cartRes = await fetch('/cart.js');
      const cartData = await cartRes.json();
      const cartCount = document.querySelector('[data-cart-count]');
      const cartCountText = document.querySelector('[data-cart-count-text]');

      if (cartCount) {
        cartCount.textContent = cartData.item_count;
        cartCount.classList.toggle('is-empty', cartData.item_count === 0);
      }

      if (cartCountText) {
        cartCountText.textContent = `(${cartData.item_count})`;
      }
    } catch (err) {
      console.error('Cart refresh error:', err);
    }
  };

  const updateLineQty = async (lineKey, qty) => {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: qty })
      });

      if (!res.ok) {
        throw new Error('Cart update failed');
      }

      await refreshCart();
    } catch (err) {
      console.error('Update qty error:', err);
    }
  };

  const attachCartItemListeners = () => {
    cartDrawer?.querySelectorAll('[data-qty-decrease]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.qtyDecrease;
        const input = cartDrawer.querySelector(`[data-qty-input="${key}"]`);

        if (input) {
          const newQty = Math.max(0, parseInt(input.value) - 1);

          input.value = newQty;
          updateLineQty(key, newQty);
        }
      });
    });

    cartDrawer?.querySelectorAll('[data-qty-increase]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.qtyIncrease;
        const input = cartDrawer.querySelector(`[data-qty-input="${key}"]`);

        if (input) {
          const newQty = parseInt(input.value) + 1;

          input.value = newQty;
          updateLineQty(key, newQty);
        }
      });
    });

    cartDrawer?.querySelectorAll('[data-qty-input]').forEach(input => {
      let timeout;

      input.addEventListener('change', () => {
        clearTimeout(timeout);

        timeout = setTimeout(() => {
          const key = input.dataset.qtyInput;
          const qty = Math.max(0, parseInt(input.value) || 0);

          updateLineQty(key, qty);
        }, 300);
      });
    });

    cartDrawer?.querySelectorAll('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.cartRemove;
        updateLineQty(key, 0);
      });
    });
  };

  attachCartItemListeners();

  document.addEventListener('cart:add', async () => {
    await refreshCart();

    if (window.__edmeOpenCart) {
      window.__edmeOpenCart();
    }
  });

  document.addEventListener('cart:updated', refreshCart);

  /* ==========================================================================
     ========== UNIFIED EVENT HANDLER (DRAWER + OVERLAY MANAGEMENT) ===========
     ========================================================================== */

  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const overlay = document.querySelector('[data-overlay]');

  // Aramayı görsel olarak gizle / göster.
  let _searchHideTimer = null;

  function hideSearchUI() {
    // Sınıfı kaldır → CSS kapanış geçişi (animasyon) düzgün oynar. (display:none YOK)
    document.querySelectorAll('[data-search-overlay]').forEach(el => {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-search-backdrop]').forEach(el => {
      el.classList.remove('is-open', 'is-active');
      el.setAttribute('aria-hidden', 'true');
    });

    // Güvenlik ağı: geçiş bittikten SONRA garanti gizle. Bu sırada tekrar
    // açıldıysa (search-open varsa) dokunma.
    clearTimeout(_searchHideTimer);
    _searchHideTimer = setTimeout(() => {
      if (document.body.classList.contains('search-open')) return;
      document.querySelectorAll('[data-search-overlay]').forEach(el => { el.style.display = 'none'; });
      document.querySelectorAll('[data-search-backdrop]').forEach(el => { el.style.display = 'none'; });
    }, 380);
  }

  function showSearchUI() {
    clearTimeout(_searchHideTimer);                // bekleyen gizlemeyi iptal et

    const overlays = document.querySelectorAll('[data-search-overlay]');
    const backdrops = document.querySelectorAll('[data-search-backdrop]');

    // 1) Önce görünür yap (inline display'i temizle) — ama henüz is-open ekleme.
    overlays.forEach(el => {
      el.style.display = '';
      el.setAttribute('aria-hidden', 'false');
    });
    backdrops.forEach(el => {
      el.style.display = '';
      el.setAttribute('aria-hidden', 'false');
    });

    // 2) Reflow zorla → tarayıcı "görünür" başlangıç durumunu kaydeder.
    void document.body.offsetWidth;

    // 3) Şimdi is-open ekle → CSS geçişi (açılış animasyonu) baştan düzgün oynar.
    overlays.forEach(el => el.classList.add('is-open'));
    backdrops.forEach(el => el.classList.add('is-active'));
  }

  function closeAll() {
    mobileMenu?.classList.remove('is-open');
    mobileMenu?.setAttribute('aria-hidden', 'true');

    cartDrawer?.classList.remove('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'true');

    hideSearchUI();

    overlay?.classList.remove('is-active');

    document.body.classList.remove('menu-open', 'cart-open', 'search-open');
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');

    if (typeof restoreTrigger === 'function') {
      restoreTrigger();
    }

    document.querySelector('.header')?.classList.remove('search-trigger-as-input');

    releaseHeaderAfterSearch();
  }

  function openMobileMenu() {
    setScrollbarWidth();
    closeAll();

    mobileMenu?.classList.add('is-open');
    mobileMenu?.setAttribute('aria-hidden', 'false');

    overlay?.classList.add('is-active');

    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'true');

    document.body.classList.add('menu-open');
  }

  function openCartDrawer() {
    setScrollbarWidth();
    closeAll();

    cartDrawer?.classList.add('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'false');

    overlay?.classList.add('is-active');

    document.body.classList.add('cart-open');
  }

  window.__edmeOpenCart = openCartDrawer;

  const headerSearchTrigger = document.querySelector('.header__search-trigger');
  let headerSearchInput = null;
  let savedTriggerHTML = null;

  function morphTriggerToInput() {
    if (!headerSearchTrigger || !isDesktop()) return;
    if (headerSearchInput) return;

    savedTriggerHTML = headerSearchTrigger.innerHTML;

    const placeholder = headerSearchTrigger.querySelector('.header__search-trigger-text')?.textContent?.trim()
      || 'Ürün, koleksiyon ara...';

    headerSearchTrigger.innerHTML = `
      <input type="search"
             class="header__search-trigger-input"
             placeholder="${placeholder}"
             autocomplete="off"
             autocapitalize="off"
             spellcheck="false"
             style="flex:1;background:transparent;border:0;outline:0;font-family:inherit;font-size:13px;color:var(--color-text);padding:0;">
      <button type="button" class="header__search-trigger-close" data-search-close aria-label="Kapat"
              style="display:flex;align-items:center;justify-content:center;width:24px;height:24px;background:none;border:0;cursor:pointer;padding:0;color:var(--color-text);">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" style="pointer-events:none;">
          <line x1="5" y1="5" x2="19" y2="19"/>
          <line x1="19" y1="5" x2="5" y2="19"/>
        </svg>
      </button>
    `;

    headerSearchInput = headerSearchTrigger.querySelector('.header__search-trigger-input');

    document.querySelector('.header')?.classList.add('search-trigger-as-input');

    let debounce;

    headerSearchInput.addEventListener('input', (event) => {
      clearTimeout(debounce);

      const q = event.target.value.trim();

      // Boşaldıysa beklemeden varsayılana dön (mobil input ile aynı davranış)
      if (q.length < 1) {
        resetPredictiveSearch();
        return;
      }

      debounce = setTimeout(() => {
        performPredictiveSearch(q);
      }, 180);
    });

    headerSearchInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();

        const q = headerSearchInput.value.trim();

        if (q.length >= 1) {
          saveRecentSearch(q);
          window.location.href = '/search?q=' + encodeURIComponent(q);
        }
      } else if (event.key === 'Escape') {
        closeSearch();
      }
    });

    headerSearchInput.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    requestAnimationFrame(() => {
      forceHeaderVisibleForSearch();
    });

    setTimeout(() => {
      forceHeaderVisibleForSearch();
      headerSearchInput?.focus({ preventScroll: true });
    }, 50);
  }

  function restoreTrigger() {
    if (!headerSearchTrigger || !savedTriggerHTML) return;

    headerSearchTrigger.innerHTML = savedTriggerHTML;
    headerSearchInput = null;
    savedTriggerHTML = null;

    document.querySelector('.header')?.classList.remove('search-trigger-as-input');
  }

  function openSearch() {
    setScrollbarWidth();

    forceHeaderVisibleForSearchWithRetries();

    closeAll();

    forceHeaderVisibleForSearchWithRetries();

    showSearchUI();

    document.body.classList.add('search-open');

    forceHeaderVisibleForSearchWithRetries();

    renderRecentSearches();

    if (isDesktop()) {
      morphTriggerToInput();
    } else {
      setTimeout(() => {
        forceHeaderVisibleForSearch();
        document.querySelector('[data-search-input]')?.focus({ preventScroll: true });
      }, 300);
    }
  }

  function closeSearch() {
    hideSearchUI();

    overlay?.classList.remove('is-active');

    document.body.classList.remove('search-open');

    const liveInput = document.querySelector('[data-search-input]');
    if (liveInput) {
      liveInput.value = '';
    }

    resetPredictiveSearch();

    restoreTrigger();

    document.querySelector('.header')?.classList.remove('search-trigger-as-input');

    releaseHeaderAfterSearch();
  }

  document.querySelector('[data-menu-toggle]')?.addEventListener('click', (event) => {
    event.stopPropagation();
    event.preventDefault();

    const isOpen = mobileMenu?.classList.contains('is-open');

    if (isOpen) {
      closeAll();
    } else {
      openMobileMenu();
    }
  });

  document.querySelector('[data-menu-close]')?.addEventListener('click', (event) => {
    event.stopPropagation();
    closeAll();
  });

  document.querySelectorAll('[data-submenu-toggle]').forEach(toggle => {
    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      toggle.closest('.mobile-menu__item')?.classList.toggle('is-open');
    });
  });

  /* --------------------------------------------------------------------------
     SEARCH AÇMA — delegasyon (bubble). Mobil + desktop tüm toggle'lar.
     Kapatma butonuna basıldıysa açma tetiklenmez.
     -------------------------------------------------------------------------- */
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-search-toggle]');
    if (!toggle) return;

    // X / morph-close butonuna basıldıysa açma — capture handler kapatır
    if (event.target.closest('[data-search-close], .header__search-trigger-close')) return;

    event.stopPropagation();
    event.preventDefault();

    forceHeaderVisibleForSearchWithRetries();

    const isOpen = document.querySelector('[data-search-overlay]')?.classList.contains('is-open');
    if (isOpen) return;

    openSearch();
  });

  /* --------------------------------------------------------------------------
     SEARCH KAPATMA — CAPTURE aşamasında delegasyon (ASIL FIX).
     Capture aşaması, morph X'inin / trigger'ın stopPropagation'ından ÖNCE
     çalışır; X her zaman kapatır, yanlışlıkla yeniden açılmaz.
     Hem overlay X'i (data-search-close), hem desktop morph X'i
     (.header__search-trigger-close), hem de backdrop yakalanır.
     -------------------------------------------------------------------------- */
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-search-close], .header__search-trigger-close')) {
      event.preventDefault();
      event.stopPropagation();
      closeSearch();
      return;
    }

    if (event.target.closest('[data-search-backdrop]')) {
      event.preventDefault();
      event.stopPropagation();
      closeSearch();
    }
  }, true); // <-- CAPTURE

  document.querySelector('[data-cart-toggle]')?.addEventListener('click', (event) => {
    event.stopPropagation();
    event.preventDefault();
    openCartDrawer();
  });

  document.querySelector('[data-cart-close]')?.addEventListener('click', (event) => {
    event.stopPropagation();
    closeAll();
  });

  overlay?.addEventListener('click', closeAll);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (
        mobileMenu?.classList.contains('is-open') ||
        cartDrawer?.classList.contains('is-open') ||
        document.querySelector('[data-search-overlay]')?.classList.contains('is-open')
      ) {
        closeAll();
      }
    }
  });

  console.log('[Header] Unified event handlers attached (v3 — 1-char search + sidebar toggle)');
})();